import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { Observable } from 'rxjs';

import { AdministratorService } from '../services';
import { Administrator } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AdministratorResolver implements Resolve<Administrator> {

  constructor(private administratorService: AdministratorService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Administrator> {
    return this.administratorService.getCurrent();
  }
}
